import StarBorderIcon from "@mui/icons-material/StarBorder";
import {Box, Stack} from "@mui/material";
import React from "react";
import {QuestionEditorProps} from "./questionEditor.types";
import ScaleLabelFields from "./ScaleLabelFields";
import {STAR_VALUES, starIconSx, starRatingRowSx} from "../../runner/questions/starRatingLayout";

function StarsQuestionEditor(props: QuestionEditorProps) {
    return (
        <Stack gap={2}>
            <Box sx={starRatingRowSx} aria-hidden>
                {STAR_VALUES.map(value => (
                    <StarBorderIcon key={value} sx={{...starIconSx, color: 'primary.main'}}/>
                ))}
            </Box>

            {props.scaleLabelsVisible && <ScaleLabelFields {...props}/>}
        </Stack>
    );
}

export default StarsQuestionEditor;
